import React, { useContext, useEffect, useState } from "react";
import disableScroll from "disable-scroll";
import "./Popup.scss";
// import Input from "../Input";
import { Rating } from "semantic-ui-react";
import moment from "moment";
import { logsAdd } from "../../../services/firebase/firestore/saveData";
import DropDown from "../DropDown";
import Graph from "../../_dashboard/graph";
import { Link } from "react-router-dom";
import UserContext from "../../../services/context/userContext";
import { getMealplanFromClient, getWorkoutFromClient } from "../../../services/firebase/firestore/getData";


let InputRepetitions = ({ repetitionsArr }) => {
    let [repetitions, setRepetitions] = useState("")
    const handelSetRepetetitions = (e, i) => {
        console.log("index", i)
        setRepetitions(e.target.value)
        repetitionsArr.push(e.target.value)
        console.log("reeee", repetitionsArr)
    }
    return (
        <div className="loging-input-block" style={{ marginRight: "7px" }}>

            <label className="loging-input-label">Repetitions</label>

            <input className="loging-inputs" name={`repetitions`} value={repetitions} onChange={handelSetRepetetitions} />

        </div>
    )
}

let InputResistance = ({ resistanceArr }) => {
    let [resistance, setResistance] = useState("")
    const handleResistance = (e) => {
        setResistance(e.target.value)
        resistanceArr.push(e.target.value)
        console.log("resistance arr", resistanceArr)
    }
    return (
        <div className="loging-input-block" style={{ marginRight: "7px" }}>

            <label className="loging-input-label">Resistance</label>

            <input className="loging-inputs" value={resistance} onChange={handleResistance} />
        </div>
    )
}

let SliderRirs = ({ rirs, rirVal }) => {
    let [rirSlider, setRirSlider] = useState(0)
    let handleRirSlider = (e) => {
        setRirSlider(e.target.value)
        rirs.push(e.target.value)
        console.log("rirs", rirs)
    }
    return (
        <div className="loging-input-block" style={{ marginTop: "7px" }}>

            <label className="loging-input-label">RIR:{rirSlider ? rirSlider : rirVal}</label>
            {/* <input className="loging-inputs" value={""} /> */}
            <input
                type='range'
                min={0}
                max={10}
                // step={0.1}
                value={rirSlider ? rirSlider : rirVal}
                onChange={handleRirSlider}
            /><br />
            {/* <Rating rating={proteinSlider} maxRating={5} /> */}
            <Rating rating={rirSlider ? rirSlider : rirVal} maxRating={10} />
        </div>

    )
}
let SliderRpes = ({ reps, rpeVal }) => {
    let [rep, setRep] = useState(0)
    const handelRepSlider = (e) => {
        setRep(e.target.value)
        reps.push(e.target.value)
        console.log("reps", reps)
    }
    return (
        <div className="loging-input-block" style={{ marginTop: "7px", marginRight: "7px" }}>

            <label className="loging-input-label">RPE: {rep ? rep : rpeVal}</label>

            <input
                type='range'
                min={0}
                max={10}
                // step={0.1}
                value={rep ? rep : rpeVal}
                onChange={handelRepSlider}
            /><br />

            <Rating rating={rep ? rep : rpeVal} maxRating={10} />
        </div>
    )

}

let Notes = ({ notes, setNotes, NotesVal }) => {
    let [note, setNote] = useState("")

    const handleNotes = (e) => {
        setNote(e.target.value);
        if (note.length >= 1) {

            notes.push(e.target.value);
            console.log("notes", notes)
        }
        // setNotes([...e.target.value])
        //   console.log("notes", notes)

    }
    return (
        <div className="loging-input-block" style={{}}>

            <label className="loging-input-label">Notes</label>

            <textarea className="loging-notes" style={{ width: "100%" }} value={note ? note : NotesVal || ""} onChange={handleNotes}></textarea>

        </div>
    )
}

export default function ProfilePopup({ exerciseId,time, client_detail, getLogs, setLoggingBtn, supersets, client_id, isSetLoging, sets, savePopup, onCancel, onAction, title, button, deletePopup, description }) {
    console.log("profile pop_up client detail",client_detail)
    const [selectedClientId, setSelectedClientId] = useState(false);
    const [totalMeals, setTotalMeals] = useState(0);
    const [totalCalories, setTotalCalories] = useState(0);
    const [totalCaloriesDone, setTotalCaloriesDone] = useState(0);

    const [totalExercises, setTotalExercises] = useState(0);
    const [exercisesDone, setExercisesDone] = useState(0);
    const [totalExerciseTime, setTotalExerciseTime] = useState(0);
    let url = new URL(window.location.href);
    const [searchValue, setSearchValue] = useState('');
   
    let user=useContext(UserContext)
    useEffect(() => {
        console.log("client detail popup", client_detail)
    }, [client_detail])

    useEffect(() => {
        debugger
        if (client_detail) {
            debugger
            var userId=client_detail.id;
            // clients.forEach(element => {
            //     if (element.name == client_name) {
            //         userId = element.id;
            //         // setSelectedClientId(element.id);
            //     }
            // });
            //meals 
            getMealplanFromClient(userId, time, (result) => {
                console.log(time);
                console.log(result);
                if (result) {

                    setTotalMeals(result.plan.length);
                    setTotalCalories(result.totalCaloriesAllowed);
                    var caloriesDone = 0;
                    result.plan.map((item) => {
                        item.food.map((item) => {
                            if (item.eaten) {
                                caloriesDone = parseInt(caloriesDone) + parseInt(item.calories);
                            }
                        })
                    })
                    setTotalCaloriesDone(caloriesDone);
                } else {
                    setTotalMeals(0);
                    setTotalCalories(0);
                    setTotalCaloriesDone(0);
                }
            });
            //workouts
            getWorkoutFromClient(userId, time, (result) => {
                if (result) {
                    console.log(result);
                    let totalExerciseAmount = 0;
                    let totalExercisesDone = 0;
                    let totalSecondsExercises = 0;

                    result.supersets.map((item) => {
                        item.exercises.map((item) => {
                            totalExerciseAmount++;
                            if (item.completed) {
                                totalExercisesDone++;
                            }

                            // totalSecondsExercises = parseInt(totalSecondsExercises) + (((parseInt(item.up) + parseInt(item.up_pause) + parseInt(item.down_pause) + parseInt(item.down) + parseInt(item.rest_time_in_minutes))* parseInt(item.reps))* parseInt(item.sets)) 
                        })
                    })

                    console.log(totalSecondsExercises);

                    setTotalExercises(totalExerciseAmount);
                    setExercisesDone(totalExercisesDone);
                    // setTotalExerciseTime(parseInt(totalSecondsExercises/60).toFixed(0));
                } else {
                    setTotalExercises(0);
                    setExercisesDone(0);
                    setTotalExerciseTime(0);
                }
            });
        }
    }, [ time, client_detail])

    useEffect(() => {
        // disableScroll.on();
        return () => {
            // disableScroll.off();
        };
    }, []);
    let setLogs = []
    let j = 3;
    let date=new Date()
    console.log("date now",date.getFullYear())


    return (
        <>
        <div className="c-popup-back" onClick={() => onCancel()} />
      <div className={`c-popup ${deletePopup ? "--delete" : ""}`} style={{width:"80%",position:"fixed"}}>
            <div className="c-page-wrapper client-detail-progress"  style={{borderRadius:"2px"}}>
                <div className="c-page-main ">
                    {/* <Invoices user={user}></Invoices> */}
                    <div className="c-page-data-grid">
                        <div className="c-page-graph">
                        <div style={{display:"flex",alignItems:"center",marginBottom:"5px",}}>
                                <img src={client_detail.image} style={{width:"40px",height:"40px",marginRight:"5px",borderRadius:"6px"}} />
                            <h2 style={{fontSize: "25px",fontWeight: 700}} >{client_detail.first_name+" "+client_detail.last_name}</h2>
                        </div>
                            {/* <DropDown options={filterName ? filterName : []} value={filter} onChange={(e) => { setFilter(e); setCLientName(e); }} /> */}
                            {/* <Graph dayAmount="31" user={user} clientName={client_detail.first_name} selectedClientId={client_detail.id}></Graph> */}
                            <div className="box">
                            <div className="c-box-data--row">
                                
                                <h3>Personal detail</h3>
                                
                            </div>
                            <div className="c-box-data--row">
                                <p>Full Name</p>
                                <p>{client_detail.first_name+" "+client_detail.last_name}</p>
                            </div>
                            <div className="c-box-data--row">
                                <p>weight</p>
                                <p>{client_detail.measurements?client_detail.measurements.weight+" "+"Kg":""}</p>
                            </div>
                            <div className="c-box-data--row">
                                <p>Height</p>
                                <p>{client_detail.measurements?client_detail.measurements.length+" "+"cm":""}</p>
                            </div>
                            <div className="c-box-data--row">
                                <p>Gender</p>
                                <p>{client_detail.gender?client_detail.gender:"Not mentioned"}</p>
                            </div>
                            <div className="c-box-data--row">
                                <p>Age</p>
                                <p>{client_detail.date_of_birth?date.getFullYear()-client_detail.date_of_birth.toDate().getFullYear():"Not mentioned"}</p>
                            </div>
                        </div>
                        </div>
                        <div className="box">
                            <div className="c-box-data--row">
                                <h3>Mealplan</h3>
                                {client_detail.id && <Link className="c-box-data--link"
                                    to={{
                                        pathname: "clients/" + client_detail.id,
                                        state: { clientPage: "Mealplan" }
                                    }}>
                                    View Mealplan
                                </Link>}
                            </div>
                            <div className="c-box-data--row">
                                <p>Meals</p>
                                <p>{totalMeals}</p>
                            </div>
                            <div className="c-box-data--row">
                                <p>Total calories</p>
                                <p>{totalCalories}</p>
                            </div>
                            <div className="c-box-data--row">
                                <p>Total calories logged</p>
                                <p>{totalCaloriesDone}</p>
                            </div>
                        </div>
                        <div className="box">
                            <div className="c-box-data--row">
                                <h3>Workout</h3>
                                {client_detail.id && <Link className="c-box-data--link"
                                    to={{
                                        pathname: "clients/" + client_detail.id,
                                        state: { clientPage: "Workout" }
                                    }}>
                                    View Workout
                                </Link>}
                            </div>
                            <div className="c-box-data--row">
                                <p>Total exercises planned</p>
                                <p>{totalExercises}</p>
                            </div>
                            <div className="c-box-data--row">
                                <p>Completed exercises</p>
                                <p>{exercisesDone}</p>
                            </div>
                            {/* <div className="c-box-data--row">
                <p>Total time of workout</p>
                <p>{totalExerciseTime}m</p>
              </div> */}
                        </div>
                    </div>

                </div>
            </div>
            </div>
        </>
    );
}
